module.exports = __webpack_public_path__ + "img/mgh-nihonbashi-premier@2x.62a375e7.jpg";